module.exports = __webpack_public_path__ + "img/course-publish-statistics-active.8bf72ca4.svg";